export const isMac = () => /mac/i.test( navigator.platform );
